import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import { User } from '@app/modules/core/interfaces/user';

export const reloadUserAlertsAction = createAction(type('[Global/Data] Reload user alerts'),
  props<{ user: User }>());
  
